export default "__VITE_ASSET__umjlxUqm__"